import { EnvelopeIcon, PhoneIcon } from "@heroicons/react/24/outline"
import useTranslations from "hooks/useTranslations"
import cc from "classcat"

const themes = {
  dark: {
    text: "text-zinc-50",
    textDimmed: "text-zinc-400",
  },
  light: {
    text: "text-zinc-800",
    textDimmed: "text-zinc-500",
  },
  lightyellow: {
    text: "text-zinc-800",
    textDimmed: "text-zinc-500",
  },
}

const ContactInfo = ({
  person,
  title = "",
  theme = "dark",
  showTitle = true,
}) => {
  const { formFieldPhone, formFieldEmail, formMoreInfo } = useTranslations()

  return (
    <div className="form flex grow flex-col justify-end">
      {showTitle && (
        <h2 className="mt-8 text-3xl font-extrabold tracking-tight">
          <span className="text-zinc-100">{title || formMoreInfo}</span>
        </h2>
      )}
      <div className={cc([themes[theme]?.text])}>
        <h3 className="mb-0 text-lg font-extrabold tracking-tight sm:text-xl">
          {person.name}
        </h3>
        <p
          className={cc([
            "mb-0 text-base leading-snug",
            themes[theme]?.textDimmed,
          ])}
        >
          {person.position}
        </p>
        <dl className="mt-3 text-sm">
          <div className="mt-3">
            <dt className="sr-only">{formFieldEmail}</dt>
            <a href={`mailto:${person.email}`}>
              <dd className="flex items-center">
                <EnvelopeIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
                <span className="ml-3 md:ml-0 lg:ml-2">{person.email}</span>
              </dd>
            </a>
          </div>
          <div className="mt-3">
            <dt className="sr-only">{formFieldPhone}</dt>
            <a href={`tel:${person.phone.replace(/\s+/g, "")}`}>
              <dd className="flex items-center">
                <PhoneIcon className="h-4 w-4 shrink-0" aria-hidden="true" />
                <span className="ml-3 md:ml-0 lg:ml-2">{person.phone}</span>
              </dd>
            </a>
          </div>
        </dl>
      </div>
    </div>
  )
}

export default ContactInfo
